import { Controller } from 'stimulus';
import '../../assets/javascript/pannellum';

export default class extends Controller {
  state = {
    fullscreen: false,
    viewers: [],
  };

  get panolens() {
    return document.querySelector('.panolens');
  }

  get panolensImage() {
    return document.querySelector('.panolens__src');
  }

  connect() {
    this.init360Player();
  }

  init360Player() {
    const { src: imageURL, title } = this.panolens.dataset;
    const rotation = this.panolens.dataset.rotation || "0";
    const customHotspots = [];
    const scenes = {
      default: {
        yaw: parseFloat(rotation),
        type: 'equirectangular',
        panorama: imageURL,
        autoLoad: true,
        showControls: false,
        compass: false,
        mouseZoom: false,
        autoRotate: -1,
        hotSpots: customHotspots,
      },
    };

    // Create Custom Hotspots
    if (this.panolens.dataset.hotspots) {
      const parsedHotspots = JSON.parse(this.panolens.dataset.hotspots.replaceAll('=>', ':'));
      parsedHotspots.forEach((item) => {
        const cleanedText = item.text.replaceAll(' ', '_').toLowerCase();
        const newHotspot = {
          yaw: parseFloat(item.x_axis),
          pitch: parseFloat(item.y_axis),
          type: 'scene',
          text: item.text,
          sceneId: cleanedText,
          cssClass: 'custom-hotspot',
          createTooltipFunc: this.styleHotspots,
          createTooltipArgs: item.text,
        };

        const newScene = {
          yaw: parseFloat(item.starting_point) || 0,
          type: 'equirectangular',
          panorama: item.asset.url,
          showControls: false,
          compass: false,
          mouseZoom: false,
          autoRotate: -1,
          hotSpots: [
            {
              pitch: 0,
              yaw: 0,
              type: 'scene',
              text: 'Back',
              sceneId: 'default',
              cssClass: 'custom-hotspot',
              createTooltipFunc: this.styleHotspots,
              createTooltipArgs: 'Back',
            },
          ],
        };

        scenes[cleanedText] = newScene;
        customHotspots.push(newHotspot);
      });
    }

    const options = {
      default: {
        firstScene: 'default',
        sceneFadeDuration: 1000,
      },
      scenes: scenes,
    };

    const viewer = pannellum.viewer('panorama', options);

    document.getElementById('fullscreen').addEventListener('click', () => {
      viewer.toggleFullscreen();
    });
  }

  styleHotspots(div, args) {
    const span = document.createElement('span');
    const icon = document.createElement('img');
    const panolens = document.querySelector('.panolens');
    div.classList.add('custom-tooltip');
    span.innerHTML = args;
    icon.src = panolens.dataset.plus;
    div.appendChild(icon);
    div.appendChild(span);
  }
}
